module.exports = __webpack_public_path__ + "img/carro.41f2ba5d.png";